var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningAmber24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99844 21.5L13 2.5009L23.9984 21.5018L1.99844 21.5ZM20.5286 19.5015L12.9997 6.4909L5.46861 19.5003L20.5286 19.5015ZM11.9989 16.5008L11.9987 18.5008L13.9987 18.501L13.9989 16.501L11.9989 16.5008ZM11.9993 10.5008L13.9993 10.501L13.999 14.501L11.999 14.5008L11.9993 10.5008Z",
    fill: "#F8761D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmber24Px);
export default __webpack_public_path__ + "static/media/warning_amber_24px.2d45d7eb9d39403be713170ef46092cb.svg";
export { ForwardRef as ReactComponent };